/** ICP / site registration chrome for examflow.cn (MIIT beian). */
export const SITE_BEIAN = {
  siteName: '考流',
  domain: 'examflow.cn',
  icpNumber: '浙ICP备2023041538号-2',
  icpHref: 'https://beian.miit.gov.cn/',
  homeUrl: 'https://examflow.cn/',
  copyrightYear: 2026,
} as const;

export function BeianFooter({
  className = '',
  siteName,
}: {
  className?: string;
  /** Optional runtime override from platform settings. */
  siteName?: string;
}) {
  const displayName = siteName?.trim() || SITE_BEIAN.siteName;
  return (
    <footer
      className={`px-4 py-4 text-center text-xs leading-5 text-ink-secondary/80 ${className}`.trim()}
    >
      <p>
        © {SITE_BEIAN.copyrightYear} {displayName}
        <span className="mx-1.5 text-ink-secondary/40" aria-hidden>
          ·
        </span>
        ExamFlow
      </p>
      <p className="mt-1">
        <a
          href={SITE_BEIAN.homeUrl}
          className="hover:text-ink-secondary hover:underline"
          rel="noopener noreferrer"
        >
          {SITE_BEIAN.domain}
        </a>
        <span className="mx-1.5 text-ink-secondary/40" aria-hidden>
          ·
        </span>
        <a
          href={SITE_BEIAN.icpHref}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-ink-secondary hover:underline"
        >
          {SITE_BEIAN.icpNumber}
        </a>
      </p>
    </footer>
  );
}
